import clsx from 'clsx';
import Footer from './Footer';
import LineContact from './LineContact';
import React from 'react';
import TopBar from './TopBar';
import {makeStyles} from '@material-ui/core';
import {Outlet} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.black,
    display: 'flex',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    paddingTop: 110, // (max depand on topBar)
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
  },
}));

const MainLayout = () => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, 'relative')}>
      <TopBar />
      <div className={classes.wrapper}>
        <div className={classes.content}>
          <Outlet />
          <Footer />
        </div>
      </div>
      <LineContact />
    </div>
  );
};

export default MainLayout;
